import { buildStateEvent, GenericStateEvent } from '../../common-redux'
import {TicketStatus} from '../incident'

export interface StatusStateEvent<T> extends GenericStateEvent<T> {}

export const GetAllStatusSuccessEvent = {
    type: 'GetAllStatusSuccessEvent',
    build: (payload: TicketStatus[]) => buildStateEvent(GetAllStatusSuccessEvent.type, payload)
}
